function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * 
 * @file Helper for the box TaskLinks API
 * @author Box
 */
import TasksBase from './TasksBase';
import { ERROR_CODE_CREATE_TASK_LINK } from '../../constants';

class TaskLinks extends TasksBase {
  getUrlForTaskLinkCreate() {
    return "".concat(this.getBaseApiUrl(), "/undoc/task_links");
  }

  createTaskLink(_ref) {
    let {
      errorCallback,
      file,
      successCallback,
      task
    } = _ref;
    this.errorCode = ERROR_CODE_CREATE_TASK_LINK;
    const requestData = {
      data: {
        target: {
          id: file.id,
          type: 'file'
        },
        task: {
          id: task.id,
          type: 'task'
        }
      }
    };
    this.post({
      id: file.id,
      url: this.getUrlForTaskLinkCreate(),
      data: _objectSpread({}, requestData),
      successCallback,
      errorCallback
    });
  }

}

export default TaskLinks;
//# sourceMappingURL=TaskLinks.js.map